import { RightFloatingButtonScalor } from "../../editor_common_components";
import { Button } from "../../../core/components/button";
import { BasicDialog } from "../../reactcomponent";
import { General } from "../../../../siteManagement/general";
import { SheetEventType } from "../../../../siteManagement/sheet";
import { TypescriptCompiler, CompilationResult } from "../../ts_compiler_services";
import { Menu, EntryType } from "../../../core/components/menu";
import { ExtraLib, MonacoEditor, MonacoEditorDiffViewer } from "../../../core/components/monacoEditor";
import React from "react";

export class ScriptEditor extends React.Component<{ onTextChange: any, value: string, label: string, customProps: { extraLibs: ExtraLib[] } }, { showDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
    }

    openEditorSheet = () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
        });

        const props: ScriptEditorProps = { value: this.props.value, extraLibs: this.props.customProps.extraLibs as ExtraLib[], onSave: this.handleSave, onClose: null };
        sheet.setTitle("Edit script. The script must be ES5 compliant");
        sheet.show(() => {
            sheet.mountContent(ScriptEditorDialog, props);
        });
    }

    render() {
        const dialog = this.state.showDialog ? <ScriptEditorDialog
            value={this.props.value || []}
            extraLibs={this.props.customProps.extraLibs}
            onClose={() => this.setState({ showDialog: false })}
            onSave={this.handleSave}></ScriptEditorDialog> : null;
        return (
            <li>
                {dialog}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={this.openEditorSheet}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        Script
                    </div>
                </div>
            </li>
        );
    }
};

interface ScriptEditorProps {
    onSave,
    onClose,
    value, extraLibs?: ExtraLib[]
}

export class ScriptEditorDialog extends React.Component<ScriptEditorProps, { initializing: boolean, diagnostics: ts.Diagnostic[], showEs5Dialog?: boolean, monacoKey: string }>{
    private code: string;
    private es5Code: string;
    private typescriptCompiler: TypescriptCompiler;

    constructor(props) {
        super(props)
        this.code = this.props.value;
        this.state = { initializing: true, diagnostics: [], monacoKey: kendo.guid() };
    }

    handleSave = () => {
        this.props.onSave && this.props.onSave(this.code);
        General.Sheet.Manager.getTopMostSheet().hide();
    }

    handleTextChangeOnBlur = (newValue) => {
        this.code = newValue;
    }

    handleTextChange = (newValue) => {
        this.code = newValue;
    }

    async componentDidMount() {
        this.typescriptCompiler = new TypescriptCompiler();
        await this.typescriptCompiler.Init();
        this.setState({ initializing: false });
    }

    handleCompileTypescript = () => {
        const codeWithMethodSignature = "function Execute(answers:" + this.props.extraLibs[0].code + ",id:any):boolean{\n" + this.code + "\n}"
        const tsDiagnostics = this.typescriptCompiler.getTypescriptDiagnostics(codeWithMethodSignature, []).diagnostics;
        const jsDiagnostics = this.typescriptCompiler.getJsDiagnostics(this.code, []).diagnostics.filter(d => d.code == 8010);
        const transpiledCode = this.typescriptCompiler.transpileToEs5(this.code)
        const codeNoSpace = this.code.replace(/\;/g, ' ').replace(/\s/g, '');
        const transpiledCodeNoSpace = transpiledCode.replace(/\;/g, ' ').replace(/\s/g, '');
        this.es5Code = transpiledCode;
        this.setState({ diagnostics: [].concat(tsDiagnostics).concat(jsDiagnostics), showEs5Dialog: codeNoSpace != transpiledCodeNoSpace });
    }

    render() {
        if (this.state.initializing) {
            return <div></div>
        }
        return (
            <>
                {this.state.showEs5Dialog ? < ES5CompareDialog
                    onClose={() => { this.setState({ showEs5Dialog: false }) }}
                    onSave={() => {
                        this.code = this.es5Code;
                        this.setState({ showEs5Dialog: false, monacoKey: kendo.guid() })
                    }}
                    enteredCode={this.code} generatedCode={this.es5Code} ></ES5CompareDialog> : null}
                <div style={{ height: "100%", display: "flex" }}>
                    <Menu entries={[
                        { type: EntryType.Save, onClick: this.handleSave },
                        { text: "Validate script", onClick: this.handleCompileTypescript },

                    ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} />
                    <MonacoEditor
                        key={this.state.monacoKey}
                        language={"typescript"}
                        extraLibs={[{ code: "let answers:" + this.props.extraLibs[0].code + ";\nlet id:any", filename: this.props.extraLibs[0].filename }]}
                        code={this.code}
                        onKeyPress={this.handleTextChange}
                        onTextChange={this.handleTextChangeOnBlur}></MonacoEditor>
                    <div style={{ width: "550px" }}>
                        <Diagnostics diagnostics={this.state.diagnostics} />
                    </div>
                </div>
            </>
        );
    }
};

class Diagnostics extends React.Component<{ diagnostics: ts.Diagnostic[] }, any>{
    render() {
        return (<div>
            <ul style={{ marginLeft: "5px", height: "50%" }}>{this.props.diagnostics && this.props.diagnostics.filter((d) => !!d.file).map((d, i) => {
                return <li key={i} style={{
                    borderColor: "red",
                    borderLeftWidth: "2px",
                    borderLeftStyle: "solid",
                    fontSize: "16px",
                    padding: "5px",
                    marginTop: "2px"
                }}>{typeof d.messageText == "string" ? d.messageText : d.messageText.messageText}</li>
            })}</ul>
        </div>
        )
    }
}

class ES5CompareDialog extends React.Component<{ onClose: any, onSave: any, enteredCode: string, generatedCode: string }, any>{
    render() {
        return <BasicDialog
            onClose={this.props.onClose}
            title="ES5"
            okayLabel="Replace code"
            onSave={this.props.onSave}>
            <div>The entered code does not match the generated ES5 code. Should the code be replaced with the generated ES5 code?</div>
            <div style={{ height: "500px", display: "flex" }}>
                <MonacoEditorDiffViewer
                    original={{ content: this.props.enteredCode, fileType: "javascript" }}
                    modified={{ content: this.props.generatedCode, fileType: "javascript" }}
                />
            </div>
        </BasicDialog>
    }
}